import { render, staticRenderFns } from "./WorkClaimSummary.vue?vue&type=template&id=4691df4c&scoped=true&"
import script from "./WorkClaimSummary.vue?vue&type=script&lang=js&"
export * from "./WorkClaimSummary.vue?vue&type=script&lang=js&"
import style0 from "./WorkClaimSummary.vue?vue&type=style&index=0&id=4691df4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691df4c",
  null
  
)

export default component.exports